<template>
  <v-app>
    <Toolbar />             
        <!-- CHAMADA DO CONTEUDO -->          
        <Content /> 
    <Footer />                               
  </v-app>
</template>

<script>
import Toolbar from './components/toolbar.vue'
import Content from './components/content.vue'
import Footer from './components/footer.vue'

export default {
  name: 'App',
  components: {
    Toolbar,
    Content,
    Footer
  },
  data () {
    return {
      //
    }
  }
}

</script>

<style>
  html {
  scroll-behavior: smooth;
  }
</style>

